import script from "./CreditTransactionTable.vue?vue&type=script&setup=true&lang=js"
export * from "./CreditTransactionTable.vue?vue&type=script&setup=true&lang=js"

import "./CreditTransactionTable.vue?vue&type=style&index=0&id=31bb03d8&scoped=true&lang=css"

import exportComponent from "/var/www/html/frontend/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-31bb03d8"]])

export default __exports__